<template>
    <section class="filter__wrapper__container">
        <div class="content">
            <div class="left">
                <div class="title">Filter</div>
                <div>
                <slot name="clear"></slot>
                <button class="filters" @click="this.$emit('update')"> 
                    <svg width="19" height="11" viewBox="0 0 19 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.5 9.75C6.5 9.55109 6.57902 9.36032 6.71967 9.21967C6.86032 9.07902 7.05109 9 7.25 9H11.75C11.9489 9 12.1397 9.07902 12.2803 9.21967C12.421 9.36032 12.5 9.55109 12.5 9.75C12.5 9.94891 12.421 10.1397 12.2803 10.2803C12.1397 10.421 11.9489 10.5 11.75 10.5H7.25C7.05109 10.5 6.86032 10.421 6.71967 10.2803C6.57902 10.1397 6.5 9.94891 6.5 9.75ZM3.5 5.25C3.5 5.05109 3.57902 4.86032 3.71967 4.71967C3.86032 4.57902 4.05109 4.5 4.25 4.5H14.75C14.9489 4.5 15.1397 4.57902 15.2803 4.71967C15.421 4.86032 15.5 5.05109 15.5 5.25C15.5 5.44891 15.421 5.63968 15.2803 5.78033C15.1397 5.92098 14.9489 6 14.75 6H4.25C4.05109 6 3.86032 5.92098 3.71967 5.78033C3.57902 5.63968 3.5 5.44891 3.5 5.25ZM0.5 0.75C0.5 0.551088 0.579018 0.360322 0.71967 0.21967C0.860322 0.0790178 1.05109 0 1.25 0H17.75C17.9489 0 18.1397 0.0790178 18.2803 0.21967C18.421 0.360322 18.5 0.551088 18.5 0.75C18.5 0.948912 18.421 1.13968 18.2803 1.28033C18.1397 1.42098 17.9489 1.5 17.75 1.5H1.25C1.05109 1.5 0.860322 1.42098 0.71967 1.28033C0.579018 1.13968 0.5 0.948912 0.5 0.75Z" fill="#292929"/>
                    </svg>
                Filter</button>
                </div>
            </div>
            <div class="right">
                <slot name="search"></slot>
                <slot name="sort"></slot>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>
.filters{
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 11px;
    border: 1.5px solid #E5E5EA;
    background: #FFFFFF;
    height: 34px;
    border-radius: 8px;
    color: #1d1d34;
    font-size: 16px;
    width: 80px;
    display: none;
}
.content{
    display: flex;
    gap: 27px;
    padding: 16px 0;
    border-top: 1px solid rgb(233, 233, 237);
    border-bottom: 1px solid rgb(233, 233, 237);
}
.left{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: calc(25% - 13.5px);
    max-width: 303px;
    gap: 16px;
}
.left > div{
    display: flex;
    gap: 12px;
}
.left .title{
    color: rgb(29, 29, 52);
    font-size: 24px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: left;
}
.right{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: calc(77% - 13.5px);
    gap: 16px;
}
@media (max-width: 1024px) {
.content{
    flex-direction: column;
}
.right,.left{
    width: 100%;
    max-width: unset;
}
.filters{
    display: flex;
}
}
@media (max-width: 600px) {
.right{
    flex-direction: column;
    align-items: unset;
}
}
</style>